import apiRequest from './apiRequest';

export type MotionQualityCheckResponse = {
  goodResults: boolean;
};

export default async function getMotionQualityCheck(prompt: string) {
  const { data, error } = await apiRequest<MotionQualityCheckResponse>(
    'mogen-orchestration',
    `/v2/motions/qualityCheck?prompt=${encodeURIComponent(prompt)}`,
  );

  return { data, error };
}
